"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gap = void 0;
require("./gap.css");
/**
 * DO NOT MODIFY
 * Generated from scripts/codegen/main.ts
 */

const gap = {
  0: "cds-0-_1a9l7cf",
  1: "cds-1-_obadkb",
  2: "cds-2-_8lqlrb",
  3: "cds-3-_zv3bp",
  4: "cds-4-_1lzchj4",
  5: "cds-5-_qfhthl",
  6: "cds-6-_1le594i",
  7: "cds-7-_s9hp40",
  8: "cds-8-_1el9wqj",
  9: "cds-9-_upczjs",
  10: "cds-10-_47tqia",
  0.5: "cds-0_5-_5akrcb",
  1.5: "cds-1_5-_j8rs45"
};
exports.gap = gap;